import { appGlobalStore } from '@/store_pinia/app';
import { Home } from '@/router/RouterNames';
import { usePaginaStore } from '@/store_pinia/paginaStore';

export const redireccionRutas = async (to, next) => {
  const appStore = appGlobalStore();
  if (appStore.permisos) {
    const { blog, nosotros, home } = appStore.permisos;
    if (
      shouldBeRedirectedByRoutePrefix(to, blog.routes_prefix, blog.showed) ||
      shouldBeRedirectedByRoutePrefix(to, nosotros.routes_prefix, nosotros.showed)
    ) {
      redirectToHome(to, next);
    } else if (shouldBeRedirectedByPathName(to, 'home', home.showed) && !(await hasHomepageDinamica())) {
      redirectToPath(home.url_redirect, to, next);
    } else {
      next();
    }
  }
};

// La homepage dinámica tiene prioridad sobre el flag home.showed. Si falla la consulta, se mantiene la redirección.
const hasHomepageDinamica = async () => {
  try {
    return !!(await usePaginaStore().fetchHomepage());
  } catch (error) {
    console.error('Error al consultar la homepage:', error);
    return false;
  }
};

const redirectToHome = (to, next) => {
  next({ name: Home, query: { redirect: to.path } });
};

// const redirectToCatalogoViajes = (to, next) => {
// 	next({ name: ViajesGrupoCatalogo, query: { redirect: to.path } });
// };

const redirectToPath = (path, to, next) => {
  if (!path.startsWith('/')) {
    path = '/' + path;
  }
  next({ path: path, query: { redirect: to.path } });
};

const shouldBeRedirectedByRoutePrefix = (currentPath, routePrefixToCheck, canBeShowed) => {
  return currentPath.fullPath.startsWith(routePrefixToCheck) && !canBeShowed;
};

const shouldBeRedirectedByPathName = (currentPath, pathNameToCheck, canBeShowed) => {
  return currentPath.name === pathNameToCheck && !canBeShowed;
};
